module.exports = "/_next/static/images/DeepenYourUnderstanding@2x-2c9666f0151133cb3aefd452fb77898e.png";